import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, switchMap } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';

@Injectable({
    providedIn: 'root'
})
export class ApiSchoolsService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    // Parties Search
    public getPartyContactMechanisms(data: any): Observable<any> {
        return this.post<any>(EndPoints.parties_getPartyContactMechanisms, false, '', data);
    }

    public getContactMechanismPurposeTypes(data: any): Observable<any> {
        return this.post<any>(
            EndPoints.parties_getContactMechanismPurposeTypes,
            false,
            '',
            data,
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        );
    }

    public getPartyRoleTypeByCategory(data: any): Observable<any> {
        return this.post<any>(
            EndPoints.parties_getPartyRoleTypeByCategory,
            false,
            '',
            data,
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        );
    }

    public deletePartyContactMechanismPurposeTypes(data: any): Observable<any> {
        return this.post<any>(EndPoints.delete_contactMechanism, false, '', data);
    }

    public createPartyContactMechanismPurposeTypes(data: any): Observable<any> {
        return this.post<any>(EndPoints.create_contactMechanism, false, '', data);
    }
    public createAllPartyContactMechanismPurposeTypes(data: any): Observable<any> {
        return this.post<any>(EndPoints.createAll_contactMechanism, false, '', data);
    }
    public updatePartyContactMechanismPurposeTypes(data: any): Observable<any> {
        return this.post<any>(EndPoints.update_contactMechanism, false, '', data);
    }

    // Schools Search
    public getAllSchools(data: any): Observable<any> {
        const url = this.urlProvider.getUrl(EndPoints.schools, undefined, undefined, undefined);
        return this.post<any>(
            EndPoints.schools,
            false,
            '',
            data,
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        );
    }

    public getSpecificSchools(data: any): Observable<any> {
        return this.post<any>(
            EndPoints.schools,
            false,
            '',
            data,
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        );
    }

    public getSpecificSchoolsShow(data: any): Observable<any> {
        return this.post<any>(
            EndPoints.schoolShow,
            false,
            '',
            data,
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        );
    }

    public show(thisSchoolId: number): Observable<any> {
        return this.get<any>(EndPoints.schoolShow, { id: thisSchoolId });
    }

    // Query Schools for autocomplete
    public searchSchoolDistricts(data: any): Observable<any> {
        return this.post<any>(
            EndPoints.schoolDistricts,
            false,
            '',
            data,
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        );
    }

    // Query Schools for Other School Types
    getOtherSubtypes(): Observable<any> {
        return this.get<any>(EndPoints.schoolTypeOther);
    }

    getSchoolStatus(): Observable<any> {
        return this.get<any>(EndPoints.schoolStatus);
    }

    checkSchoolCode(value: number, schoolID: number): Observable<any> {
        return this.post<any>(
            EndPoints.schoolCheckCode,
            false,
            '',
            { value: value, schoolID: schoolID },
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        );
    }

    checkDistrictNCES(value: number, schoolID?: number): Observable<any> {
        return this.post<any>(
            EndPoints.schoolCheckNCESDistrictCode,
            false,
            '',
            { value: value, schoolID: schoolID },
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        );
    }

    // Query Schools for Save/Updates on Edit Schools
    public updateSchoolGeneralInfo(data: any): Observable<any> {
        console.log('calling updateSchoolGeneralInfo in API schools');
        return this.post<any>(
            EndPoints.schoolUpdateGeneralInfo,
            false,
            '',
            data,
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        );
    }

    public updateSchoolContactInfo(params: any): Observable<any> {
        console.log('calling updateSchoolContactInfo in API schools');
        return this.post<any>(
            EndPoints.schoolUpdateContactInfo,
            false,
            '',
            {
                editSchool: params.editSchool,
                partyContactMechanisms: params.partyContactMechanisms,
                deletePartyContactMechanisms: params.deletePartyContactMechanisms
            },
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        );
    }

    public updateSchoolLocation(data: any): Observable<any> {
        // params: any, params2?: any
        return this.post<any>(
            EndPoints.schoolUpdateLocation,
            false,
            '',
            data,
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
            /*
             {
                editSchool: params,
                schoolBackup: params2
            }
            */
        );
    }

    // create new school post
    public createNewSchool(data: any): Observable<any> { // params: any, params2?: any

        return this.post<any>(
            EndPoints.schoolCreateNew,
            false,
            '',
           data,
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
            /*
             {
                editSchool: params,
                schoolBackup: params2
            }
            */
        );
    }

    // searchCities post
    public searchCities(data: any): Observable<any> { // params: any, params2?: any
        return this.post<any>(
            EndPoints.schoolSearchCities,
            false,
            '',
           data,
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
            /*
             {
                editSchool: params,
                schoolBackup: params2
            }
            */
        );
    }
    
}
